module.exports = __webpack_public_path__ + "8d2b75c73cd345d68d4f0dffa68f4d3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/thumbnails/order.png
// module id = 917
// module chunks = 4